module.exports = __webpack_public_path__ + "assets/img/pbtrade_product_3.af0c4671.png";